import * as React from "react";
const SvgFiBrandsAlgolia = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-algolia_svg__a)">
      <path
        fill="#151A2D"
        d="M12.789 8.073c-2.75 0-4.983 2.14-4.983 4.775s2.234 4.776 4.983 4.776c2.757 0 4.982-2.141 4.982-4.776s-2.232-4.775-4.982-4.775m3.509 3.021L13 12.732c-.098.051-.212-.022-.212-.124v-3.56c0-.08.076-.138.152-.138 1.465.051 2.734.837 3.417 1.988.038.072.015.16-.06.196m-3.51-3.021c-2.748 0-4.982 2.14-4.982 4.775s2.234 4.776 4.983 4.776c2.757 0 4.982-2.141 4.982-4.776s-2.232-4.775-4.982-4.775m3.51 3.021L13 12.732c-.098.051-.212-.022-.212-.124v-3.56c0-.08.076-.138.152-.138 1.465.051 2.734.837 3.417 1.988.038.072.015.16-.06.196M21.708 0H3.292C1.47 0 0 1.413 0 3.152v17.689C0 22.588 1.48 24 3.292 24h18.416C23.528 24 25 22.581 25 20.841V3.16C25 1.413 23.52 0 21.708 0M10.404 4.535c0-.575.487-1.041 1.086-1.041h2.53c.599 0 1.085.466 1.085 1.041v.823c0 .095-.09.16-.182.138a8.4 8.4 0 0 0-2.127-.276 8.2 8.2 0 0 0-2.202.298c-.1.022-.19-.044-.19-.138zM5.682 7.981a1.01 1.01 0 0 1 .005-1.466l.517-.495a1.12 1.12 0 0 1 1.535 0l.432.415c.06.066.053.168-.023.212q-.524.361-.98.8-.451.435-.827.932c-.06.065-.16.08-.229.015l-.425-.408q-.001-.003-.005-.005m7.107 11.645c-3.905 0-7.071-3.029-7.071-6.778s3.166-6.784 7.07-6.784c3.912 0 7.071 3.028 7.071 6.777s-3.166 6.785-7.07 6.785m0-11.553c-2.75 0-4.983 2.14-4.983 4.775s2.234 4.776 4.983 4.776c2.757 0 4.982-2.141 4.982-4.776s-2.232-4.775-4.982-4.775m3.509 3.021L13 12.732c-.098.051-.212-.022-.212-.124v-3.56c0-.08.076-.138.152-.138 1.465.051 2.734.837 3.417 1.988.038.072.015.16-.06.196"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-algolia_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsAlgolia;
